module.exports = __webpack_public_path__ + "img/ry_blue.b02ea0ea.png";